import { GoLiveFSNModel } from '../types/common';
import { ZuluUpdatePayload, ZuluUpdatePipeline } from '../types/pipeline';

export const generateDownstreamPipelinePayload = (data: string[]) => {
    const result = {
        pipelinePath: '3dFeatureProcessPipeline',
        payload: {}
    };

    data.forEach((fsn) => {
        result.payload[fsn] = {
            threeDAssetCompression: { fsn },
            threeDAssetConversion: { fsn },
            dimensionFixer: { fsn },
            threeDAssestValidations: { fsn }
        };
    });

    return result;
};

export const generateGoLivePayload = (data: GoLiveFSNModel[] | null): ZuluUpdatePayload<string> | null => {
    if (!data) return null;

    let result: ZuluUpdatePayload<string> = {
        pipelinePath: 'go_live',
        payload: {}
    };

    data.forEach((item) => {
        const { fsn, status, arInfoData } = item;
        if (status) {
            const zuluUpdatePipeline: ZuluUpdatePipeline = { fsn: fsn, updateArInfo: true, updateArSummary: true };

            if (!['Select an option'].includes(arInfoData.label)) {
                zuluUpdatePipeline.arInfoType = arInfoData.value;
            }

            Object.entries(arInfoData.meta)
                .filter(([key, objValue]) => !objValue.hidden)
                .forEach(([key, objValue]) => {
                    zuluUpdatePipeline[key] = objValue.value;
                });

            result.payload[fsn] = { zuluUpdatePipeline };
        }
    });

    return result;
};
